import React from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { Box, Button } from '@mui/material';
import AdverseEventItem from './AdverseEventItem';
import TabSaveButton from './TabSaveButton';

export default function AdverseEventForm(tabIndex) {
  const { control } = useFormContext();
  const {
    fields: aeFields,
    append: aeAppend,
    remove: aeRemove,
  } = useFieldArray({
    control,
    name: 'adverseEvents',
  });

  const FIELD_PATHS = ['groupId', 'adverseEvents'];

  const defaultValues = [
    {
      gastrointestinalSymptoms: {
        nausea: false,
        diarrhea: false,
        vomiting: false,
        abdominalPain: false,
        abdominalDistension: false,
        constipation: false,
        abdominalDiscomfort: false,
        indigestion: false,
        gastrointestinalDisorder: false,
      },
      skinSymptoms: { jaundice: false, rash: false, itching: false, hives: false },
      neuropsychiatricSymptoms: {
        headache: false,
        dizziness: false,
        drowsiness: false,
        anxiety: false,
        insomnia: false,
        tremor: false,
      },
      systemicSymptoms: {
        lossOfAppetite: false,
        fatigueMalaiseLethargy: false,
        weightLoss: false,
        edema: false,
        sweating: false,
        abnormalLiverFunctionTest: false,
        liverDysfunction: false,
        abnormalBloodTest: false,
        fever: false,
        hypertension: false,
        tachycardia: false,
        bradycardia: false,
        xerostomia: false,
      },
      entSymptoms: { xerostomia: false },
      genitourinarySymptoms: { darkColoredUrine: false, dysuria: false, vaginalBleeding: false },
      respiratorySymptoms: { dyspnea: false, cough: false },
      cardiovascularSymptoms: { palpitations: false, chestTightness: false, chestPain: false, arrhythmia: false },
      musculoskeletalSymptoms: { arthralgia: false },
      other: '',
      adverseEventStartDate: '',
      adverseEventEndDate: '',
      adverseEventCountry: '',
      adverseEventDuration: '',
      adverseEventDurationUnit: '',
      adverseEventSeverityCriteria: {
        resultsInDeath: false,
        lifeThreatening: false,
        requiresHospitalization: false,
        causesDisability: false,
        congenitalAnomaly: false,
        medicallyImportantEvent: false,
        notApplicable: false,
      },
      adverseEventHospitalization: '',
      adverseEventOutcome: '',
      diagnosticTestInfo: [
        {
          testDate: '',
          testName: '',
          testResult: '',
          testResultOp: '',
          testResultUnit: '',
          referenceRangeLower: '',
          referenceRangeUpper: '',
          resultDescription: '',
          remarks: '',
          hasAdditionalInfo: '',
        },
      ],
    },
  ];

  return (
    <Box>
      {aeFields.map((item, index) => (
        <AdverseEventItem key={item.id} index={index} removeAE={() => aeRemove(index)} />
      ))}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <TabSaveButton fieldPaths={FIELD_PATHS} label="탭 저장" index={tabIndex} />
        <Button variant="outlined" onClick={() => aeAppend(defaultValues)}>
          이상사례 추가
        </Button>
      </Box>
    </Box>
  );
}
